import { IValidityRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetValidityUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IValidityRepositoryResponse> {
    return this.lookupRepository.getValidities();
  }
}   
